import { render, staticRenderFns } from "./CurrencyPortfolioSelectors.vue?vue&type=template&id=5d317167&scoped=true&"
import script from "./CurrencyPortfolioSelectors.vue?vue&type=script&lang=js&"
export * from "./CurrencyPortfolioSelectors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d317167",
  null
  
)

export default component.exports